import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["style", "render", "count", "level"];
import { jsx as _jsx } from "react/jsx-runtime";
export var Ellipsis = _ref => {
  var {
      style,
      render,
      count,
      level
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var styl = _extends({
    cursor: 'pointer'
  }, style);
  var className = "w-rjv-ellipsis " + (props.className || '');
  if (render) return render(_extends({
    style: styl,
    count,
    level
  }, props, {
    className
  }));
  return /*#__PURE__*/_jsx("span", _extends({
    className: className,
    style: styl
  }, props, {
    children: "..."
  }));
};